import { useEffect, useState } from 'react';

import { withRouter } from 'react-router-dom';

import pushRouterHelper from 'hooks/useRouterHelper';
import RenderWithRole from 'hoc/renderWithRole';
import NotesAndDiscussions from 'views/Study/components/NotesAndDiscussions/NotesAndDiscussions';
import SubjectChapters from 'views/Study/components/Details/Student/SubjectChapters';
import GradesModal from 'views/Dashboard/components/Upcoming/components/GradesModal/GradesModal';

import TeachingStructure from '../Details/Teacher/TeachingStructure';
import StudyBottomBar from '../Study/components/StudyBottomBar/StudyBottomBar';
import STUDY from '../AssignmentDetails/STUDY';
import TASK from '../AssignmentDetails/TASK';
import IStudyQuery from '../IURLQuery';
import Card from '../../../../components/Card/Card';
import ShowStudyFiles from './components/StudyFiles/ShowStudyFiles';

import './StudyDetails.scoped.scss';
import { useGetAssignmentByIdQuery } from '@school_ify/schoolify-repository/src/student/types';

const StudyDetails = ({ match }) => {
  const { query } = pushRouterHelper<IStudyQuery>();
  const { data, refetch } = useGetAssignmentByIdQuery({
    variables: {
      id: query?.lesson?.toString(),
    },
  });
  const [modal, setModalState] = useState(false);

  const components = {
    MATERIAL: STUDY,
    TASK,
  };

  function renderAssignmentByType() {
    if (!data?.assignments_by_pk) {
      return <></>;
    }
    const ComponentToRender = components[data?.assignments_by_pk.type];
    return (
      <ComponentToRender
        key={data?.assignments_by_pk.id}
        study={data?.assignments_by_pk}
        handleModal={() => setModalState(state => !state)}
      />
    );
  }

  const rightSideBar = RenderWithRole({
    teacher: <TeachingStructure parentId={match.params.id} lessonId={query?.lesson as string} />,
    student: <SubjectChapters parentId={match.params.id} />,
  });

  useEffect(() => {
    refetch();
  }, [query]);

  const gradesModalComponent = RenderWithRole({
    teacher: (
      <GradesModal
        assignment={data?.assignments_by_pk}
        handleModal={() => {
          setModalState(state => !state);
        }}
        openModal={modal}
      />
    ),
  });

  return (
    <>
      <div className="container">
        <div>
          {gradesModalComponent}
          {renderAssignmentByType()}
          {data?.assignments_by_pk && data?.assignments_by_pk.files && (
            <Card className="mt-1">
              <Card.Body>
                <ShowStudyFiles files={data?.assignments_by_pk.files} />
              </Card.Body>
            </Card>
          )}
          <NotesAndDiscussions />
        </div>
        <div>{rightSideBar}</div>
      </div>
      {query.type && query.type !== 'structure' && <StudyBottomBar />}
    </>
  );
};

export default withRouter(StudyDetails);
